import * as m from "../../es2015/plugins/sunburst";
window.am4plugins_sunburst = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/sunburst.js
// module id = null
// module chunks = 